var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewCompactOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "view-compact-outline",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M3 5v14h19V5H3Zm2 2h15v4H5V7Zm0 10v-4h4v4H5Zm6 0v-4h9v4h-9Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewCompactOutline);
export default __webpack_public_path__ + "static/media/view-compact-outline.b162116ef0e178f6dc6b039e45e3f739.svg";
export { ForwardRef as ReactComponent };